import React, { useEffect, useState, useCallback } from "react";
import Table from "../Table";

const ListaEsperaTable = (props) => {
  const [header, setHeader] = useState([
    // "ID ESPERA",
    "NOME",
    "EMAIL",
    "CIDADE",
    "PROFISSÃO",
    "DATA",
    "ESTUDANTE",
    "ID CURSO",
    "DATA CURSO",
    // "DATA CURSO 2",
    // "DATA CURSO 3",
    "DIVULGACAO",
    "OBS",
    "ATIVO",
  ]);
  const [body, setBody] = useState([]);

  const getLineCells = useCallback(
    (item) => {
      const {
        // id,
        nome,
        email,
        cidade,
        profissao,
        data_sys,
        estudante,
        curso,
        data_curso,
        // data_curso2,
        // data_curso3,
        divulgacao,
        // obs,
        ativo,
      } = item;

      const responseArray = [
        // id,
        nome,
        email,
        cidade,
        profissao,
        data_sys,
        estudante,
        curso,
        data_curso,
        // data_curso2,
        // data_curso3,
        divulgacao,
        // obs,
        ativo,
      ];

      return responseArray;
    },
    [props]
  );

  useEffect(() => {
    const newBody = props.espera.map((item) => getLineCells(item));

    setBody(newBody);
  }, [props]);

  return <Table header={header} body={body} />;
};

export default ListaEsperaTable;
